import PropTypes from 'prop-types'
import React from 'react'
import { reduxForm, Field } from 'redux-form'
import { FormattedMessage } from 'react-intl'
import { CARD_NAME_MAX_LENGTH } from 'const/limits'
import {
  FormGroup,
  HelpBlock,
  Button,
  ControlLabel
} from 'react-bootstrap'
import Textarea from 'components/Textarea'

export class NameForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)

    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.renderField = this.renderField.bind(this)
  }

  handleKeyDown (event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.props.handleSubmit()
    }
  }

  renderField (field) {
    this.setInputValue = field.input.onChange

    const onInputFocus = (event) => {
      const tempValue = event.target.value
      event.target.value = ''
      event.target.value = tempValue
    }

    return (
      <FormGroup
        validationState={field.meta.touched && field.meta.error ? 'error' : null}>
        <ControlLabel><FormattedMessage id='NAME' /></ControlLabel>
        <Textarea
          {...field.input}
          name={null}
          autoFocus
          maxLength={CARD_NAME_MAX_LENGTH}
          onKeyDown={this.handleKeyDown}
          onFocus={onInputFocus} />
        {field.meta.touched && field.meta.error && <HelpBlock>{field.meta.error}</HelpBlock>}
      </FormGroup>
    )
  }

  render () {
    const {
      handleSubmit
    } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <Field
          name='name'
          component={this.renderField} />
        <Button type='submit' bsStyle='primary'><FormattedMessage id='SAVE' /></Button>
      </form>
    )
  }
}

export default reduxForm({
  form: 'cardNameQuickAction'
})(NameForm)
